import React from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";

export const LANDING_INFO_TABS = [
  { key: "about", labelKey: "tabs.about" },
  { key: "faq", labelKey: "tabs.faq" },
  { key: "rules", labelKey: "tabs.rules" },
  { key: "contacts", labelKey: "tabs.contacts" },
];

export function isLandingInfoTabKey(value) {
  return LANDING_INFO_TABS.some((tab) => tab.key === value);
}

export default function LandingInfoTabs({
  activeKey = "",
  onChange,
  className = "",
  maxWidthClassName = "max-w-[336px]",
}) {
  const { t } = useTranslation("about");

  return (
    <nav
      className={clsx(
        "grid h-12 w-full grid-cols-[0.82fr_0.7fr_1.03fr_1.08fr] items-center rounded-full border border-white/25 bg-white/[0.08] px-3 text-sm font-bold text-white shadow-[0_14px_42px_rgba(0,0,0,0.22)] backdrop-blur-xl",
        maxWidthClassName,
        className
      )}
      aria-label="VaultGrid information"
    >
      {LANDING_INFO_TABS.map((tab) => {
        const isActive = activeKey === tab.key;
        return (
          <button
            key={tab.key}
            type="button"
            className={clsx(
              "flex h-full min-w-0 items-center justify-center rounded-full px-0.5 whitespace-nowrap leading-none transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-300",
              isActive ? "text-sky-300" : "text-white/85 hover:text-white"
            )}
            onClick={() => onChange?.(tab.key)}
            aria-pressed={isActive}
          >
            {t(tab.labelKey)}
          </button>
        );
      })}
    </nav>
  );
}
